const routeTypes = {
    ROUTE_REMOTE_ORAL: 'remote-oral',
    ROUTE_TYPE_ALL: 'all',
    ROUTE_TYPE_AUTO_SUBMIT: 'auto-submit',
    ROUTE_TYPE_AUTO_SUBMIT_OFFLINE: 'auto-submit-offline',
    ROUTE_TYPE_DELIVERING: 'delivering',
    ROUTE_TYPE_ERROR: 'error',
    ROUTE_TYPE_ID_VERIFICATION: 'id-verification',
    ROUTE_TYPE_LOGIN: 'login',
    ROUTE_TYPE_MESSAGES: 'messages',
    ROUTE_TYPE_OPTIONS: 'options',
    ROUTE_TYPE_QUESTION: 'question',
    ROUTE_TYPE_RESULT: 'result',
    ROUTE_TYPE_ROOM_SCAN: 'room-scan',
    ROUTE_TYPE_SECTION: 'section',
    ROUTE_TYPE_STIMULUS: 'stimulus',
    ROUTE_TYPE_TEST_OVERVIEW: 'test-overview',
    ROUTE_TYPE_TOC: 'toc',

    OPTIONS_ADD_EXTRA_TIME: '/options/add-extra-time',
    OPTIONS_DELIVER_BANK: '/options/deliver-blank',
    OPTIONS_EXIT_CHROME_APP: '/options/exit-chrome-app',
    OPTIONS_EXIT_SEB: '/options/exit-seb',
    OPTIONS_FILE_DELIVERY_CHROME_APP: '/options/file-delivery-chrome-app',
    OPTIONS_FILE_DELIVERY: '/options/file-delivery',
    OPTIONS_WITHDRAW: '/options/withdraw',
};

export default routeTypes;
